import { render, staticRenderFns } from "./BatchRunWarning.vue?vue&type=template&id=54b38138&scoped=true"
import script from "./BatchRunWarning.vue?vue&type=script&lang=js"
export * from "./BatchRunWarning.vue?vue&type=script&lang=js"
import style0 from "./BatchRunWarning.vue?vue&type=style&index=0&id=54b38138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b38138",
  null
  
)

export default component.exports